/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BillingSettingsContainer_invoiceSettings$ref = any;
export type UpdateInvoiceSettingsInput = {|
  clientMutationId?: ?string,
  contactEmail?: ?string,
  contactPerson?: ?string,
  contactPhoneNumber?: ?string,
  wiringInstructions?: ?string,
|};
export type updateInvoiceSettingsMutationVariables = {|
  input: UpdateInvoiceSettingsInput
|};
export type updateInvoiceSettingsMutationResponse = {|
  +updateInvoiceSettings: ?{|
    +invoiceSettings: ?{|
      +$fragmentRefs: BillingSettingsContainer_invoiceSettings$ref
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type updateInvoiceSettingsMutation = {|
  variables: updateInvoiceSettingsMutationVariables,
  response: updateInvoiceSettingsMutationResponse,
|};
*/


/*
mutation updateInvoiceSettingsMutation(
  $input: UpdateInvoiceSettingsInput!
) {
  updateInvoiceSettings(input: $input) {
    invoiceSettings {
      ...BillingSettingsContainer_invoiceSettings
      id
    }
    errors {
      key
      messages
    }
  }
}

fragment BillingSettingsContainer_invoiceSettings on InvoiceSettings {
  id
  wiringInstructions
  contactPerson
  contactPhoneNumber
  contactEmail
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceSettingsInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateInvoiceSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateInvoiceSettingsPayload",
        "kind": "LinkedField",
        "name": "updateInvoiceSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceSettings",
            "kind": "LinkedField",
            "name": "invoiceSettings",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BillingSettingsContainer_invoiceSettings"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateInvoiceSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateInvoiceSettingsPayload",
        "kind": "LinkedField",
        "name": "updateInvoiceSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceSettings",
            "kind": "LinkedField",
            "name": "invoiceSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wiringInstructions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contactPerson",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contactPhoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contactEmail",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateInvoiceSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation updateInvoiceSettingsMutation(\n  $input: UpdateInvoiceSettingsInput!\n) {\n  updateInvoiceSettings(input: $input) {\n    invoiceSettings {\n      ...BillingSettingsContainer_invoiceSettings\n      id\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment BillingSettingsContainer_invoiceSettings on InvoiceSettings {\n  id\n  wiringInstructions\n  contactPerson\n  contactPhoneNumber\n  contactEmail\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '93e9207c71889ef2c27668681e31acdd';

module.exports = node;
